import React, { ReactNode } from 'react';
import styles from '../assets/scss/widgets/Layout.module.scss';

interface LayoutProps {
  children: ReactNode;
  noPadding?: boolean;
}

export const LayoutAuth: React.FC<LayoutProps> = ({ children, noPadding = false }) => {
  return (
    <div className={noPadding ? styles.layoutNoPadding : styles.layout}>
      {children}
    </div>
  );
};
